import { styled } from 'styled-components'

import { QueryLoadingManager } from '@b-stock/fe-core/bstock-next/components'
import { FormattedMessage, interpUri } from '@b-stock/fe-core/bstock-react'

import { ButtonLink } from '@/buyer-portal/components/ButtonLink'
import useAccountId from '@/buyer-portal/helpers/useAccountId'
import buyerOrderByListingIdQuery from '@/buyer-portal/queries/buyerOrderByListingIdQuery'

const ns = 'Offerings.Details.offeringStatusBanner.offerAccepted'

const ViewOrderButtonContainer = styled.div`
  margin-top: 0.5rem;
  a {
    width: 100%;
  }
`

export const ViewOrderDetailsButton = ({
  listingId,
}: {
  listingId: string
  appearance?: 'primary' | 'secondary'
}) => {
  const accountId = useAccountId()

  const contractDetailsResults = buyerOrderByListingIdQuery.useQuery(listingId)

  return (
    <QueryLoadingManager
      {...contractDetailsResults}
      EmptyComponent={() => null}
    >
      {({ data }) => (
        <>
          {data && accountId && data._id ? (
            <ViewOrderButtonContainer data-testid="view-order-button">
              <ButtonLink
                size="large"
                href={interpUri`/user/${accountId}/orders/details/${data._id}`}
              >
                <FormattedMessage id={`${ns}.viewOrderDetails`} />
              </ButtonLink>
            </ViewOrderButtonContainer>
          ) : null}
        </>
      )}
    </QueryLoadingManager>
  )
}
